module.exports = __webpack_public_path__ + "images/43c845f5a9290791d1d195fa0c9256b9.png";